import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import isEqual from 'fast-deep-equal';

import { RedirectToLogin } from 'components/redirects';
import { useAppSelector } from 'hooks/store';
import { AccessDenied } from 'pages/common/errors/access-denied';
import { selectIsAuthenticated, selectUser } from 'store/selectors';
import { IRouteGuardProps } from 'types/hoc/route-guard';
import { IUser } from 'types/user';
import { hasRole } from 'utilities/has-role';

export const RouteGuard: FC<IRouteGuardProps> = ({ role }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const user = useAppSelector(selectUser, isEqual) ?? ({} as IUser);

  if (!isAuthenticated) {
    // no user found, redirect to the login page
    return <RedirectToLogin />;
  }

  const isInRole = hasRole({ inRole: user.role, requiredRole: role });

  if (isInRole) {
    // user is authenticate and in the required role(s)
    return <Outlet />;
  }

  // user is authenticated, but not in the required role(s)
  return <AccessDenied />;
};
